module.exports = __webpack_public_path__ + "static/img/mtjz04.0a9981f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/mtjz04.png
// module id = NP6r
// module chunks = 11